__turbopack_context__.v({
  "footer_left": "step-company-module-scss-module__UiQmFq__footer_left",
  "grid": "step-company-module-scss-module__UiQmFq__grid",
  "required": "step-company-module-scss-module__UiQmFq__required",
});
